import React from 'react';
import PropTypes from 'prop-types';
import LegalTermsCompass from './CompassContract';
import LegalTermsNonCompass from './NonCompassContract';
import DynamicContract from './DynamicContract';

const LegalTerms = ({
    brokerageName = '',
    agentFirstName = '',
    agentLastName = '',
    navbarInfo = {},
    agentRegistrationDate = '',
    listgenUserID = '',
    hideSignatureSection = false,
    forceDynamicContract = false,
}) => {
    const cutoffDate = new Date('2026-04-01T00:00:00');
    const parsedRegistrationDate = agentRegistrationDate ? new Date(agentRegistrationDate) : null;
    const isRegistrationDateValid = parsedRegistrationDate instanceof Date && !Number.isNaN(parsedRegistrationDate.getTime());
    const useOldFallbackMethod = !isRegistrationDateValid || parsedRegistrationDate < cutoffDate;

    if (!forceDynamicContract && useOldFallbackMethod) {
        return brokerageName === 'Compass'
            ? (
                <LegalTermsCompass
                    agentFirstName={agentFirstName}
                    agentLastName={agentLastName}
                    navbarInfo={navbarInfo}
                    brokerageName={brokerageName}
                    agentRegistrationDate={agentRegistrationDate}
                    listgenUserID={listgenUserID}
                    hideSignatureSection={hideSignatureSection}
                />
            )
            : (
                <LegalTermsNonCompass
                    agentFirstName={agentFirstName}
                    agentLastName={agentLastName}
                    navbarInfo={navbarInfo}
                    brokerageName={brokerageName}
                    agentRegistrationDate={agentRegistrationDate}
                    listgenUserID={listgenUserID}
                    hideSignatureSection={hideSignatureSection}
                />
            );
    }

    return (
        <DynamicContract
            agentFirstName={agentFirstName}
            agentLastName={agentLastName}
            navbarInfo={navbarInfo}
            brokerageName={brokerageName}
            agentRegistrationDate={agentRegistrationDate}
            listgenUserID={listgenUserID}
            hideSignatureSection={hideSignatureSection}
        />
    )
};

LegalTerms.propTypes = {
    agentFirstName: PropTypes.string,
    agentLastName: PropTypes.string,
    navbarInfo: PropTypes.object,
    brokerageName: PropTypes.string,
    agentRegistrationDate: PropTypes.string,
    listgenUserID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hideSignatureSection: PropTypes.bool,
    forceDynamicContract: PropTypes.bool,
};

export default LegalTerms;

